import { useContextState } from "../../../../../../hooks/theme"


export const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            '& .MuiTypography-root': {
                fontSize: '16px',
                fontWeight: '500',
            }
        },
        paper:{
            display:'flex',
            padding: '16px 16px',
            justifyContent: 'space-evenly',
            alignItems: 'center'
        },
        item: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent:' center',
            gap: '4px',
            '& .MuiTypography-root': {
                textAlign: 'center'
            }
        }
    }
}
